(function ($) {
    "use strict";

    var self = null;
    var wasTextListReset = false;
    var hasPendingDocuments = false;
    var TEXT_LIST_DROPDOWN_SELECTOR = ".js-text-list-attribute-dropdown";
    var TEXT_LIST_INPUT_SELECTOR = ".js-text-list-attribute-input";
    var DATA_CUSTOMER_ATTRIBUTE_TYPE_ID = "customer-attribute-type-id";
    var DOCUMENT_WRAPPER_SELECTOR = ".js-document-upload-wrapper";
    var DOCUMENT_APPROVAL_WRAPPER_SELECTOR = ".js-document-approval-wrapper";
    var DATA_DOCUMENT_TYPE_ID = "document-type-id";
    var DATA_HAS_PENDING_DOCUMENTS = "has-pending-documents";
    var DOCUMENT_EXPIRATION_PENDING_SELECTOR = ".js-document-expiration";
    var DOCUMENT_EXPIRATION_APPROVED_SELECTOR = ".js-document-expiration-approved";
    var DOCUMENT_EXPIRATION_INPUT_SELECTOR = "input.js-document-expiration-input";
    var DOCUMENT_DISABLED_EXPIRATION_INPUT_SELECTOR = "input.js-disabled-document-expiration";

    ori.addModule("identityCardExpiration", {
        init: function (options) {
            self.setOptions(options);
            hasPendingDocuments = getHasPendingDocuments(self.options.idCardDocumentTypeId);

            $("body").on("change", TEXT_LIST_DROPDOWN_SELECTOR, function () {
                var $this = $(this);
                var customerAttributeTypeId = $this.data(DATA_CUSTOMER_ATTRIBUTE_TYPE_ID);
                if (customerAttributeTypeId === self.options.idCardNumberTextListAttributeTypeId) {
                    var selectedTextListId = parseInt($this.val());
                    var showExpirationDate = self.options.hideIdCardExpirationForTextListIds.indexOf(selectedTextListId) < 0;
                    
                    var $documentWrapper = getDocumentWrapper(self.options.idCardDocumentTypeId);
                    if (!$documentWrapper.length) {
                        return;
                    }
                    var $dropdownPending = $(DOCUMENT_EXPIRATION_PENDING_SELECTOR, $documentWrapper);
                    var $dropdownApproved = $(DOCUMENT_EXPIRATION_APPROVED_SELECTOR, $documentWrapper);
                    var $dropdownInput = $(DOCUMENT_EXPIRATION_INPUT_SELECTOR, $documentWrapper);
                    var $disabledInput = $(DOCUMENT_DISABLED_EXPIRATION_INPUT_SELECTOR, $documentWrapper);
                    
                    var showPendingDropdown = showExpirationDate && (!self.options.hasApprovedIdCard || hasPendingDocuments);
                    var showApprovedDropdown = showExpirationDate && self.options.hasApprovedIdCard && !hasPendingDocuments;

                    $dropdownPending.toggleClass("hidden", !showPendingDropdown);
                    $dropdownApproved.toggleClass("hidden", !showApprovedDropdown);
                    if ($dropdownInput.prop("disabled") === showExpirationDate) {
                        $dropdownInput.data("kendoDropDownDatePicker").enable(showExpirationDate);
                        $dropdownInput.prop("disabled", !showExpirationDate);
                        $disabledInput.prop("disabled", showExpirationDate);
                        if (!showExpirationDate) {
                            $dropdownInput.data("kendoDropDownDatePicker").value("");
                        }
                    }
                }
            });

            $("body").on("documentItemRemoved", DOCUMENT_WRAPPER_SELECTOR, function (e) {
                if (e.originalEvent.detail.DocumentTypeId !== self.options.idCardDocumentTypeId || e.originalEvent.detail.ContainsNewItems) {
                    return;
                }
                hasPendingDocuments = false;
                if (!self.options.hasApprovedIdCard) {
                    return;
                }
                wasTextListReset = false;
                var textListDropdown = getTextListDropdown(self.options.idCardNumberTextListAttributeTypeId);
                var textListInput = getTextListInput(self.options.idCardNumberTextListAttributeTypeId);
                
                if (textListDropdown) {
                    textListDropdown.value(self.options.approvedIdCardTextListId);
                    textListDropdown.readonly(true);
                    textListDropdown.trigger("change");
                    textListDropdown.element.trigger("change");
                }
                if (textListInput) {
                    textListInput.value(self.options.approvedIdCardNumber);
                    textListInput.readonly(true);
                    textListInput.trigger("change");
                    textListInput.element.trigger("change");
                }
            });

            $("body").on("documentItemAdded", DOCUMENT_WRAPPER_SELECTOR, function (e) {
                if (e.originalEvent.detail.DocumentTypeId !== self.options.idCardDocumentTypeId) {
                    return;
                }
                hasPendingDocuments = true;
                if (!self.options.hasApprovedIdCard || wasTextListReset) {
                    return;
                }
                wasTextListReset = true;
                var textListDropdown = getTextListDropdown(self.options.idCardNumberTextListAttributeTypeId);
                var textListInput = getTextListInput(self.options.idCardNumberTextListAttributeTypeId);

                if (textListDropdown) {
                    textListDropdown.select(1);
                    textListDropdown.readonly(false);
                    textListDropdown.trigger("change");
                    textListDropdown.element.trigger("change");
                }
                if (textListInput) {
                    textListInput.value("");
                    textListInput.readonly(false);
                    textListInput.trigger("change");
                    textListInput.element.trigger("change");
                }
            });

            initializeExpirationDateToggle(self.options.idCardNumberTextListAttributeTypeId);
        },
    });

    function getDocumentWrapper(idCardDocumentTypeId) {
        var $documentWrapper = $(DOCUMENT_WRAPPER_SELECTOR + "[data-" + DATA_DOCUMENT_TYPE_ID + "=" + idCardDocumentTypeId +"]");
        if ($documentWrapper.length) {
            return $documentWrapper;
        }
        return $(DOCUMENT_APPROVAL_WRAPPER_SELECTOR + "[data-" + DATA_DOCUMENT_TYPE_ID + "=" + idCardDocumentTypeId +"]");
    }

    function getHasPendingDocuments(idCardDocumentTypeId) {
        var $documentWrapper = getDocumentWrapper(idCardDocumentTypeId);
        if (!$documentWrapper.length) {
            return false;
        }
        return $documentWrapper.data(DATA_HAS_PENDING_DOCUMENTS);
    }

    function getTextListDropdown(idCardNumberTextListAttributeTypeId) {
        var dropdown = $(TEXT_LIST_DROPDOWN_SELECTOR + "[data-" + DATA_CUSTOMER_ATTRIBUTE_TYPE_ID + "=" + idCardNumberTextListAttributeTypeId + "]");
        return dropdown ? dropdown.data("kendoDropDownList") : dropdown;
    }

    function getTextListInput(idCardNumberTextListAttributeTypeId) {
        var input = $(TEXT_LIST_INPUT_SELECTOR + "[data-" + DATA_CUSTOMER_ATTRIBUTE_TYPE_ID + "=" + idCardNumberTextListAttributeTypeId + "]");
        return input ? input.data("kendoTextBox") : input;
    }

    function initializeExpirationDateToggle(idCardNumberTextListAttributeTypeId) {
        var dropdown = getTextListDropdown(idCardNumberTextListAttributeTypeId);
        if (dropdown) {
            dropdown.trigger("change");
            dropdown.element.trigger("change");
        }
    }

    self = ori.customerAttributes;
})(jQuery);
